module.exports = __webpack_public_path__ + "img/lotery-rewards-2.7b006337.webp";